var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.type==='insights')?_c('InsightsTemplate'):(_vm.type==='dashboard-access')?_c('DashboardAccessLoader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }